import {
  ProgramWithDetails,
  ProgramYearsDistribution,
} from './types/programs/program.type';
import { ProgramStatus } from './types/programs/program-status';
import { ProgramMetadata } from './types/programs/program-metadata';
import { CourseStatus } from './types/programs/course/course-status';
import { DateClassesScheduleRequest } from './types/api-model';
import { CalenderModel } from './types/calender/calender-model';
import { ClassScheduleModel } from './types/calender/class-schedule/class-schedule-model';
import { BaseEntity } from './types/base-entity';
import { ScheduleDetailsType } from './types/calender/class-schedule/schedule/schedule-details-details';
import dateUtils, { WeekDay } from '../utils/date-format';
import { ClassMetadata } from './types/settings/branches/buildings/classes/class-metadata';
import { CourseAssignment } from './types/programs/course/assignments/course-assignment';
import {
  Gender,
  MaritalStatus,
  UserSummaryType,
} from './types/user/user-summary.type';
import { UserType } from './types/user/user-type';
import { SettingsBranches } from './types/settings/branches/settings-branches';
import { SettingsBuilding } from './types/settings/branches/buildings/settings-building';
import { Major } from './types/settings/studies/major';
import { AbstractCourse } from './types/settings/studies/abstract-course';
import { AssignmentType } from './types/settings/studies/assignment-type';
import axios, { AxiosResponse, HttpStatusCode } from 'axios';
import { ExamType } from './types/settings/studies/exam-type';
import {
  PollWithQuestionsResponse,
  SettingsAll,
  UserProfile,
} from './types/settings/settings-all';
import { AbstractProgram } from './types/settings/studies/abstract-program';
import { SupervisoryInstitution } from './types/settings/studies/supervisory-institution';
import { AbstractExternalExam } from './types/settings/studies/abstract-external-exam';
import { ExternalExamGroup } from './types/external-exams/external-exam-group';
import {
  CreateExternalExamGroupRequest,
  CreateExternalExamGroupExamRequest,
  UpdateExternalExamGroupRequest,
  UpdateExternalExamGroupExamRequest,
} from './types/external-exams/external-exam-group-crud';
import {
  ExternalExamRegistrationStudentDetails,
  RegistrationSourceType,
} from './types/external-exams/registration/external-exam-student-registration-eligibility';
import { SettingsDocsType } from './types/settings/docs/settings-docs-type';
import { SettingsServicePaymentType } from './types/settings/payments/settings-service-payment-type';
import { PaymentServiceWithVersionsResponseType } from './types/payments/payment-template';
import { CourseMetadataType } from './types/programs/course/course-metadata.type';
import {
  BranchPermissionStatus,
  Permission,
} from './types/user/permissions/update-user-permission-request';
import {
  PaymentType,
  SettingsLecturersRateType,
} from './types/settings/lecturers/settings-lecturers-rate-type';
import { LecturerRateDisplayType } from './types/lecturers/price-rate/lecturer-rate-display-type';
import {
  BranchLecturerRateEntity,
  LecturerRatesById,
  UserDetailsLecturerRes,
} from './types/lecturers/user-details-lecturer';
import { AssignmentStudent } from './types/assignment-student-details/response/assignment-student-db';
import { StudentAssignmentUpsertRequest } from './types/assignment-student-details/request/upsert/request-upsert-assignment-details';
import { UserAttendanceRequest } from './types/lecturers/attendance/user-attendance-request';
import { LectureDetails } from './types/lecturers/details/lecture-details';
import { CustomErrorForClient } from './types/errors/custom-error-for-client';
import { UserDetailsStudent } from './types/students/user-details-student';
import { UserDetailsAdministrationResponse } from './types/administration/user-details-administration';
import { PaymentResponse } from './types/payments/gateway/payment-gateway-response';
import { DocFeedbackStatusDB } from './types/docs/doc-feedback-status';
import { DocMetadata } from './types/docs/doc-metadata';
import { RequestEnrollment } from './types/programs/course/exams/requests/request-exam-enrollment-update';
import { CalendarScheduleFlat } from './types/calender/calendar-schedule-flat';
import { HomeData } from './types/home-data/home-data';
import { RequestRateType } from './types/lecturers/price-rate/request-rate/request-rate-type';
import { LectureWithSessions } from './types/programs/course/lectures/lecture-with-schedule-metadata';
import { CourseFullInfo } from './types/programs/course/course-info';
import { AvailabilityResponse } from './types/calender/avalability-slots/availability-response';
import { SerialLecturesRequest } from './types/calender/serial/serial-lectures-request';
import { SettingsClassesAttributeEntity } from './types/settings/class-attributes/settings-class-attributes';
import { ClassAttributeType } from './types/settings/class-attributes/class-attribute-types';
import {
  ExamMetadata,
  ExamSessionDetails,
  SessionType,
} from './types/programs/course/exams/response/exam-metadata';
import { AdvanceSearchUserDetails } from '../pages/users/advance-search/operations/advance-search-operation';
import { ApiErrorCodes } from './errors/api-error-codes';
import { ScholarshipFundersEntities } from './types/settings/scholarship-funders';
import { ProgramStudentStatus } from './types/programs/students/program-student-status';
import { StudentDropOutReportDb } from './types/reports/student-drop-out-report-db';
import { StudentStatusInCourseReportResultDb } from './types/reports/student-status-in-course/student-status-in-course-report-result-db';
import { CourseHoursExceedingReport } from './types/reports/finanace/course-hours-excess-report';
import { CourseFinancialAmongBranchesType } from './types/reports/finanace/course-financial-among-branches.type';
import { CheckType } from './types/reports/accountant/check.type';
import {
  InstallmentReportRow,
  PaymentInstallmentStatus,
} from './types/reports/accountant/installment.type';
import { InstallmentBankTransferReportRow } from './types/reports/accountant/installment-bank-transfer-report.type';
import { RealEstateReportType } from './types/reports/finanace/real-estate-report.type';
import { ProgramComparisonAmongBranchesDb } from './types/reports/finanace/program-comparison-among-branches';
import { ReportGeneralAttendanceType } from './types/reports/education/report-general-attendance.type';
import { ReportLecturesType } from './types/reports/education/report-lectures.type';
import {
  LectureStatus,
  LectureStatusType,
} from './types/programs/course/lectures/lecture-status.type';
import { ExamSteps } from './types/reports/education/exams/report-exam-statuses';
import { ExamSessionReport } from './types/reports/education/exams/report-exam.types';
import { ReportProgramResponseType } from './types/reports/education/programms/report-program-response.type';
import { ReportCoursesType } from './types/reports/education/courses/report-courses.type';
import { LecturesResType } from '../pages/lectures/operations/get-lectures-data-operation';
import { FinancialData } from '../pages/reports/finance/course-financial-branch-breakdown/course-financial-branch-breakdown';
import { HighOverviewReportTypeRes } from './types/reports/high-overview/high-overview.type';
import { LegalEntityType } from '../pages/user-page/roles/lecturer-price-rate/componenets/acountant/user-page-lecturer-rate-accountant';
import { ProfessorsSalariesStatusesType } from './types/accountants/salaries-statuses/professors-salaries-statuses.type';
import { PendingPaymentBranch } from './types/accountants/salaries-pending-payments/salaries-pending-payments.type';
import { SalaryHistoryDbType } from './types/accountants/salary-history/salary-history.type';
import {
  WorkingHoursResponse,
  WorkingHoursStatus,
} from './types/lecturers/working-hours/working-hours.type';
import { CheckStatusType } from './types/students/payment-services/user-payments/user-payment-service-with-price-list';
import { PasswordResetType } from './types/auth/reset-password-type';

import { ProgramFinancialBreakdown } from './types/reports/finanace/program-breakdown/program-breakdown-income.type';
import { UserRoleEntity } from './types/user/entities/user-role-entity';
import { StudentGradesByProgramType } from './types/programs/external-exams/program-external-exam';
import { PaginationResponse } from './types/shared/pagination.types';

interface ServiceMajorResponse {
  ok: boolean;
  body: Major;
}

interface GenericResponse<T> {
  ok: boolean;
  body: T;
  errCode?: ApiErrorCodes;
}

class AppApi {
  // TODO change to better practice!

  baseUrl = '';
  private axiosInstance;

  constructor() {
    const environment = process.env.NODE_ENV;
    if (environment === 'development') {
      this.baseUrl = 'http://localhost:3000';
    } else if (environment === 'production') {
      this.baseUrl = 'https://api.charedicts.com';
    }

    this.axiosInstance = axios.create({
      baseURL: this.baseUrl,
      withCredentials: true,
    });

    // Add timezone to all requests automatically

    this.axiosInstance.interceptors.request.use((config) => {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      config.headers['X-Timezone'] = timezone;
      return config;
    });

    // Add response interceptor to handle PASSWORD_CHANGE_REQUIRED
    this.axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (
          axios.isAxiosError(error) &&
          error.response?.data?.errCode ===
            ApiErrorCodes.PASSWORD_CHANGE_REQUIRED
        ) {
          const currentPath = window.location.pathname + window.location.search;

          // Only redirect if we're not already on the password change page
          if (!currentPath.includes('/change-password-required')) {
            // Store current location to redirect back after password change
            sessionStorage.setItem('redirectAfterPasswordChange', currentPath);
            window.location.href = '/change-password-required';
          }
        }
        return Promise.reject(error);
      },
    );
  }

  async get<T>(
    endpoint: string,
    params?: Record<string, any>,
  ): Promise<AxiosResponse<GenericResponse<T>>> {
    try {
      const res = await this.axiosInstance.get(`${endpoint}`, {
        params,
      });
      return res;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response?.status === HttpStatusCode.Unauthorized) {
          console.error('Unauthorized access - please log in again.');
          window.location.href = '/login';
          throw error;
        }
        throw error;
      }

      throw error;
    }
  }

  async post<T>(
    endpoint: string,
    payload: any,
  ): Promise<AxiosResponse<GenericResponse<T>>> {
    try {
      const res = await this.axiosInstance.post<GenericResponse<T>>(
        `${endpoint}`,
        payload,
      );
      return res;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response?.status === HttpStatusCode.Unauthorized) {
          console.error('Unauthorized access - please log in again.');
          window.location.href = '/login';
          throw error;
        }
        throw error;
      }

      throw error;
    }
  }

  async put<T>(
    endpoint: string,
    payload: any,
  ): Promise<AxiosResponse<GenericResponse<T>>> {
    try {
      const res = await this.axiosInstance.put(`${endpoint}`, payload);
      return res;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response?.status === HttpStatusCode.Unauthorized) {
          console.error('Unauthorized access - please log in again.');
          window.location.href = '/login';
          throw error;
        }
        throw error;
      }

      throw error;
    }
  }

  async delete<T>(
    endpoint: string,
  ): Promise<AxiosResponse<GenericResponse<T>>> {
    try {
      const res = await this.axiosInstance.delete(`${endpoint}`);
      return res;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response?.status === HttpStatusCode.Unauthorized) {
          console.error('Unauthorized access - please log in again.');
          window.location.href = '/login';
          throw error;
        }
        throw error;
      }

      throw error;
    }
  }

  async patch<T>(
    endpoint: string,
    payload: any,
  ): Promise<AxiosResponse<GenericResponse<T>>> {
    try {
      const res = await this.axiosInstance.patch(`${endpoint}`, payload);
      return res;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response?.status === HttpStatusCode.Unauthorized) {
          console.error('Unauthorized access - please log in again.');
          window.location.href = '/login';
          throw error;
        }
        throw error;
      }

      throw error;
    }
  }

  getHome = async (
    branchId: number,
    dateRangeStartOfLectures: Date,
    dateRangeEndOfLectures: Date,
  ) => {
    return await this.post<HomeData>('/reports/general-view-of-branch', {
      branchId: branchId,
      dateRangeStartOfLectures: dateRangeStartOfLectures,
      dateRangeEndOfLectures: dateRangeEndOfLectures,
    });
  };

  activateProgram = async (
    branchId: number,
    abstractProgramId: number,
    startYear: number,
  ): Promise<AxiosResponse<GenericResponse<ProgramWithDetails>>> => {
    // TODO retrieve data from the axios
    return await this.post<ProgramWithDetails>(
      `/branches/${branchId}/programs`,
      {
        abstractProgramId: abstractProgramId,
        startYear: startYear,
      },
    );
  };

  getPrograms = async (
    branchId: number,
  ): Promise<AxiosResponse<GenericResponse<ProgramMetadata[]>>> => {
    // http://localhost:3000/programs/list
    return await this.get<ProgramMetadata[]>(
      `/branches/${branchId}/programs/list`,
    );
    /*return await axios.get(
      `${this.baseUrl}/branches/${branchId}/programs/list`,
    );*/
  };

  getProgramDetails = async (
    branchId: number,
    programId: number,
  ): Promise<AxiosResponse<GenericResponse<ProgramYearsDistribution>>> => {
    return await this.get<ProgramYearsDistribution>(
      `/branches/${branchId}/programs/${programId}/details`,
    );
    /*return await axios.get(
      `${this.baseUrl}/branches/${branchId}/programs/${programId}/details`,
    );*/
  };

  getProgramExternalExamDetails = async (
    branchId: number,
    programId: number,
  ): Promise<AxiosResponse<GenericResponse<StudentGradesByProgramType>>> => {
    return await this.get<StudentGradesByProgramType>(
      `/branches/${branchId}/programs/${programId}/details/external-exams`,
    );
    /*return await axios.get(
      `${this.baseUrl}/branches/${branchId}/programs/${programId}/details`,
    );*/
  };

  deleteCourseFromProgram = async (
    branchId: number,
    programId: number,
    courseId: number,
  ): Promise<AxiosResponse<GenericResponse<ProgramWithDetails>>> => {
    return await this.delete<ProgramWithDetails>(
      `/programs/${programId}/courses/${courseId}`,
    );
  };

  deletePaymentServiceFromProgram = async (
    branchId: number,
    programId: number,
    year: number,
    paymentServiceId: number,
  ): Promise<AxiosResponse<GenericResponse<ProgramWithDetails>>> => {
    return await this.delete<ProgramWithDetails>(
      `/branches/${branchId}/programs/${programId}/years/${year}/payment-services/${paymentServiceId}`,
    );
  };

  deleteStudentFromProgram = async (
    branchId: number,
    programId: number,
    programYear: number,
    studentId: number,
  ): Promise<AxiosResponse<GenericResponse<ProgramWithDetails>>> => {
    return await this.delete<ProgramWithDetails>(
      `/branches/${branchId}/programs/${programId}/years/${programYear}/students/${studentId}`,
    );
  };

  updateCourseStatus = async (
    programId: number,
    courseId: number,
    courseStatus: CourseStatus,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return this.post<any>(
      `/programs/${programId}/courses/${courseId}/update-status`,
      {
        status: courseStatus,
      },
    );
  };

  updateCourseNotes = async (
    programId: number,
    courseId: number,
    notes: string,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.put<any>(
      `/programs/${programId}/courses/${courseId}/notes`,
      {
        notes: notes,
      },
    );
  };

  getCourseDetails = async (
    programId: number,
    courseId: number,
  ): Promise<AxiosResponse<GenericResponse<CourseFullInfo>>> => {
    return await this.get<CourseFullInfo>(
      `/programs/${programId}/courses/${courseId}/details`,
    );
    /*return await axios.get(
      `${this.baseUrl}/programs/${programId}/courses/${courseId}/details`,
    );*/
  };

  removeStudentFromCourse = async (
    programId: number,
    courseId: number,
    userId: number,
  ): Promise<AxiosResponse<GenericResponse<CourseFullInfo>>> => {
    return await this.delete<CourseFullInfo>(
      `/programs/${programId}/courses/${courseId}/students/${userId}`,
    );
  };

  removeLecturerFromCourse = async (
    programId: number,
    courseId: number,
    lecturerId: number,
  ): Promise<AxiosResponse<GenericResponse<CourseFullInfo>>> => {
    return await this.delete<CourseFullInfo>(
      `/programs/${programId}/courses/${courseId}/lecturers/${lecturerId}`,
    );
  };

  getAllCoursesMetadata = async (filter: {
    branchIds: number[];
    abstractProgramIds: number[];
    programStartYears: number[];
    programYears: number[];
    courseStartDateFrom?: Date;
    courseStartDateTo?: Date;
    courseStatus: CourseStatus[];
    majorIds: number[];
    abstractCourseIds: number[];
    lecturerIds: number[];
  }): Promise<AxiosResponse<GenericResponse<ReportCoursesType[]>>> => {
    try {
      return await this.post<ReportCoursesType[]>(
        `/reports/education/courses`,
        filter,
      );
    } catch (error) {
      console.error('Error fetching courses metadata:', error);
      throw error;
    }
  };

  createNewLecture = async (
    programId: number,
    courseId: number,
    classId: number,
    lectureName: string,
    lecturersWithActivityTypeIds: {
      lecturerId: number;
      activityTypeId: number;
    }[],
    startTime: Date,
    endTime: Date,
  ): Promise<AxiosResponse<GenericResponse<LectureWithSessions[]>>> => {
    return await this.post<LectureWithSessions[]>(
      `/programs/${programId}/courses/${courseId}/lectures`,
      {
        lectureName: lectureName,
        classId: classId,
        lecturersWithActivityTypeIds: lecturersWithActivityTypeIds,
        startTime: startTime,
        endTime: endTime,
      },
    );
  };

  createNewSerialLectures = async (
    programId: number,
    courseId: number,
    lecturesReq: SerialLecturesRequest,
    attendanceRequired: boolean,
  ): Promise<AxiosResponse<GenericResponse<LectureWithSessions[]>>> => {
    return await this.post<LectureWithSessions[]>(
      `/programs/${programId}/courses/${courseId}/lectures/serial`,
      {
        requests: lecturesReq,
        attendanceRequired: attendanceRequired,
      },
    );
  };

  getClassesScheduling = async (
    classRequest: DateClassesScheduleRequest[],
  ): Promise<CalenderModel> => {
    console.log(classRequest);

    const entity: BaseEntity = {
      createdBy: 1,
      createdByName: 'asd',
      createdAt: new Date(),
    };
    const schedulesDetilas = {
      type: ScheduleDetailsType.lecture,
      data: {
        id: 1,
        lectureParts: [],
        lectureSubject: 'asd',
        ...entity,
      },
    };

    const getClassMetadata = (id: number): ClassMetadata => {
      return {
        id: id,
        className: 'ClassA',
        attributes: [],
        ...entity,
      };
    };
    const cale: CalenderModel = {
      calender: new Map<string, ClassScheduleModel[]>(),
    };
    const classIds = [1, 2, 3, 4, 5, 6];
    if (classRequest) {
      classRequest.forEach((classRequestItem) => {
        const formatDate = dateUtils.storeFormatDate(
          classRequestItem.startTime,
        );

        // Initialize an array to store schedules for this date
        const schedules = classIds.map((classId, classIdIndex) => ({
          classMetadata: getClassMetadata(classId),
          schedules: [
            {
              metadata: {
                id: 1,
                startTime: dateUtils.addMinutesToDate(
                  classRequestItem.startTime,
                  classIdIndex % 2 === 0 ? -15 : -15,
                ),
                endTime: dateUtils.addMinutesToDate(
                  classRequestItem.startTime,
                  classIdIndex % 2 === 0 ? 120 : -10,
                ),
                ...entity,
              },
              details: schedulesDetilas, // Assuming schedulesDetilas is defined earlier
            },
          ],
        }));

        // Set the formatted date and corresponding schedules in the calendar
        cale.calender.set(formatDate, schedules);
      });
    }
    return cale;
  };

  updateTask = async (
    id: number,
    taskName: string,
    taskPoints: number,
    dueDate: Date,
  ) => {
    return;
  };

  addNewTask = async (
    programId: number,
    courseId: number,
    taskName: string,
    taskPoints: number,

    dueDate: string,
    assignmentTypeId: number,
  ): Promise<AxiosResponse<GenericResponse<CourseFullInfo>>> => {
    return await this.post<CourseFullInfo>(
      `/programs/${programId}/courses/${courseId}/assignments`,
      {
        assignmentName: taskName,
        dueDate: dueDate,
        weight: taskPoints,
        assignmentTypeId: assignmentTypeId,
      },
    );
  };

  getAssignmentPreSignUrl = async (
    programId: number,
    courseId: number,
    assignmentId: number,
    fileType: string,
  ): Promise<AxiosResponse<GenericResponse<string>>> => {
    return await this.get<string>(
      `/programs/${programId}/courses/${courseId}/assignments/${assignmentId}/files?fileType=${fileType}`,
    );
  };

  deleteAssignment = async (
    programId: number,
    courseId: number,
    assignmentId: number,
  ): Promise<AxiosResponse<GenericResponse<CourseFullInfo>>> => {
    return await this.delete<CourseFullInfo>(
      `/programs/${programId}/courses/${courseId}/assignments/${assignmentId}`,
    );
  };

  updateAssignment = async (
    programId: number,
    courseId: number,
    assignmentId: number,
    assignmentName: string,
    assignmentDueDate: Date | null,
  ): Promise<AxiosResponse<GenericResponse<CourseFullInfo>>> => {
    return await this.put<CourseFullInfo>(
      `/programs/${programId}/courses/${courseId}/assignments/${assignmentId}`,
      {
        assignmentName: assignmentName,
        dueDate: assignmentDueDate,
      },
    );
  };

  deleteAssignmentFile = async (
    programId: number,
    courseId: number,
    assignmentId: number,
  ): Promise<AxiosResponse<GenericResponse<CourseFullInfo>>> => {
    return await this.delete<CourseFullInfo>(
      `/programs/${programId}/courses/${courseId}/assignments/${assignmentId}/file`,
    );
  };

  uploadAssignmentFile = async (
    programId: number,
    courseId: number,
    assignmentId: number,
    fileUrl: string,
    fileName: string,
  ): Promise<AxiosResponse<GenericResponse<CourseFullInfo>>> => {
    return await this.put<CourseFullInfo>(
      `/programs/${programId}/courses/${courseId}/assignments/${assignmentId}/files`,
      {
        fileUrl: fileUrl,
        fileName: fileName,
      },
    );
  };

  getAssignmentStudentPreSignUrl = async (
    programId: number,
    courseId: number,
    assignmentId: number,
    studentId: number,
    fileType: string,
  ): Promise<AxiosResponse<GenericResponse<string>>> => {
    return await this.get<string>(
      `/programs/${programId}/courses/${courseId}/assignments/${assignmentId}/student-data/${studentId}/pre-sign-url?fileType=${fileType}`,
    );
  };

  assignmentStudentFileUploadedNotifyBackend = async (
    programId: number,
    courseId: number,
    assignmentId: number,
    studentId: number,
    fileUrl: string,
    fileName: string,
  ): Promise<AxiosResponse<GenericResponse<AssignmentStudent[]>>> => {
    return await this.put<AssignmentStudent[]>(
      `/programs/${programId}/courses/${courseId}/assignments/${assignmentId}/student-data/${studentId}/file`,
      {
        fileUrl: fileUrl,
        fileName: fileName,
      },
    );
  };

  upsertStudentsAssignmentData = async (
    programId: number,
    courseId: number,
    assignmentId: number,
    studentsData: StudentAssignmentUpsertRequest[],
  ): Promise<AxiosResponse<GenericResponse<CourseAssignment>>> => {
    return await this.post<CourseAssignment>(
      `/programs/${programId}/courses/${courseId}/assignments/${assignmentId}/student-data/upsert`,
      {
        studentsAssignments: studentsData,
      },
    );
  };

  deleteStudentAssignmentFile = async (
    programId: number,
    courseId: number,
    assignmentId: number,
    studentId: number,
  ): Promise<AxiosResponse<GenericResponse<AssignmentStudent[]>>> => {
    return await this.delete<AssignmentStudent[]>(
      `/programs/${programId}/courses/${courseId}/assignments/${assignmentId}/student-data/${studentId}`,
    );
  };

  getAssignmentData = async (
    programId: number,
    courseId: number,
    assignmentId: number,
  ): Promise<AxiosResponse<GenericResponse<AssignmentStudent[]>>> => {
    return await this.get<AssignmentStudent[]>(
      `/programs/${programId}/courses/${courseId}/assignments/${assignmentId}/details`,
    );

    /*return await axios.get(
      `${this.baseUrl}/programs/${programId}/courses/${courseId}/assignments/${assignmentId}/details`,
    );*/
  };

  searchUsers = async (searchText: string, userType: UserType[]) => {
    const students: UserSummaryType[] = [
      {
        id: 1,
        firstName: 'יצחק',
        lastName: 'רבינוביץ',
        email: 'david.r@gmail.com',
        phoneNumber: '0528589283',
        dateOfBirth: new Date(),
        nationalId: '314768898',
        role: userType[0],
      },
      {
        id: 2,
        firstName: 'מוטי',
        lastName: 'רבינוביץ',
        email: 'david.r@gmail.com',
        phoneNumber: '0528589283',
        dateOfBirth: new Date(),
        nationalId: '314768898',
        role: userType[0],
      },
      {
        id: 4,
        firstName: 'דויד',
        lastName: 'רבינוביץ',
        email: 'david.r@gmail.com',
        phoneNumber: '0528589283',
        dateOfBirth: new Date(),
        nationalId: '314768898',
        role: userType[0],
      },
    ];
    return students;
  };

  getUserLecturerDetails = async (
    userId: number,
  ): Promise<AxiosResponse<GenericResponse<UserDetailsLecturerRes>>> => {
    return await this.get<UserDetailsLecturerRes>(
      `/users/${userId}/details/lecturer`,
    );
    /*axios.get(`${this.baseUrl}/users/${userId}/details/lecturer`);*/
  };

  getUserStudentDetails = async (
    userId: number,
  ): Promise<AxiosResponse<GenericResponse<UserDetailsStudent>>> => {
    return await this.get<UserDetailsStudent>(
      `/users/${userId}/details/student`,
    );
    //axios.get(`${this.baseUrl}/users/${userId}/details/student`);
  };

  getUserAdministrationDetails = async (
    userId: number,
  ): Promise<
    AxiosResponse<GenericResponse<UserDetailsAdministrationResponse>>
  > => {
    return await this.get<UserDetailsAdministrationResponse>(
      `/users/${userId}/details/administration`,
    );
  };

  addUserPermission = async (
    userId: number,
    branchId: number,
  ): Promise<
    AxiosResponse<GenericResponse<UserDetailsAdministrationResponse>>
  > => {
    return await this.post<UserDetailsAdministrationResponse>(
      `/users/${userId}/permissions/`,
      {
        branchId: branchId,
        userId: userId,
      },
    );
  };

  removeUserPermission = async (
    userId: number,
    permissionId: number,
  ): Promise<
    AxiosResponse<GenericResponse<UserDetailsAdministrationResponse>>
  > => {
    return await this.delete<UserDetailsAdministrationResponse>(
      `/users/${userId}/permissions/${permissionId}`,
    );
  };

  getUserLecturerPaymentRateByBranchId = async (
    userIds: number[],
    branchId: number,
  ): Promise<AxiosResponse<GenericResponse<LecturerRatesById>>> => {
    return await this.get<LecturerRatesById>(
      `/branches/${branchId}/lecturers/payment-rate?lecturerIds=${userIds.join(',')}`,
    );
    /*axios.get(
        `${this.baseUrl}/branches/${branchId}/lecturers/payment-rate?lecturerIds=${userIds.join(',')}`,
    );*/
  };

  getAdvanceSearch = async (
    userRole: UserType | undefined,
    offset: number,
    limit: number,
    firstName?: string,
    userDetails?: AdvanceSearchUserDetails,
    majorIds?: number[],
    abstractCoursesIds?: number[],
    abstractProgramIds?: number[],
    programStartYear?: number,
    branchIds?: number[],
  ): Promise<
    AxiosResponse<GenericResponse<PaginationResponse<UserSummaryType>>>
  > => {
    const requestBody: Record<string, any> = {};

    requestBody.offset = offset;
    requestBody.limit = limit;
    requestBody.userRole = userRole;

    // Only add firstName to the request body if it has a value
    if (firstName !== undefined && firstName !== '') {
      requestBody.firstName = firstName;
    }

    if (userDetails !== undefined) {
      requestBody.userDetails = userDetails;
    }

    if (majorIds !== undefined && majorIds.length > 0) {
      requestBody.majorIds = majorIds;
    }

    if (abstractCoursesIds !== undefined && abstractCoursesIds.length > 0) {
      requestBody.abstractCoursesIds = abstractCoursesIds;
    }

    if (abstractProgramIds !== undefined && abstractProgramIds.length > 0) {
      requestBody.abstractProgramIds = abstractProgramIds;
    }

    if (programStartYear !== undefined) {
      requestBody.programStartYear = programStartYear;
    }

    if (branchIds !== undefined && branchIds.length > 0) {
      requestBody.branchIds = branchIds;
    }

    // Send the request with the conditional request body
    return await this.post<PaginationResponse<UserSummaryType>>(
      `/users/advance-search`,
      requestBody,
    );
  };

  searchForUsers = async (
    branchIds: number[],
    searchText: string,
    userRole: UserRoleEntity,
  ): Promise<AxiosResponse<GenericResponse<UserSummaryType[]>>> => {
    return await this.post<UserSummaryType[]>(`/users/search`, {
      branchIds: branchIds,
      text: searchText,
      userRole: userRole,
    });
  };

  getBranches = async (): Promise<SettingsBranches[]> => {
    const response = await this.get<SettingsAll>('/settings/all');
    return response.data.body.branches;
  };

  addBranch = async (
    branchName: string,
  ): Promise<AxiosResponse<GenericResponse<SettingsBranches>>> => {
    return await this.post<SettingsBranches>(`/settings/branches`, {
      branchName: branchName,
    });
  };

  addBuildingsToBranch = async (
    branchId: number,
    buildingId: number,
  ): Promise<AxiosResponse<GenericResponse<SettingsBranches>>> => {
    return await this.post<SettingsBranches>(
      `/settings/branches/${branchId}/buildings/`,

      { buildingId: buildingId },
    );
  };

  addBuilding = async (
    buildingName: string,
  ): Promise<AxiosResponse<GenericResponse<SettingsBuilding>>> => {
    return await this.post<SettingsBuilding>(`/settings/buildings/`, {
      buildingName: buildingName,
    });
  };

  editBuilding = async (
    buildingId: number,
    buildingName: string,
  ): Promise<AxiosResponse<GenericResponse<SettingsBuilding>>> => {
    return await this.put<SettingsBuilding>(
      `/settings/buildings/${buildingId}`,
      {
        buildingName: buildingName,
      },
    );
  };

  editAssignmentTypeName = async (
    assignmentTypeId: number,
    assignmentTypeName: string,
  ): Promise<AxiosResponse<GenericResponse<SettingsBuilding>>> => {
    return await this.put<SettingsBuilding>(
      `/settings/assignment-type/${assignmentTypeId}`,
      {
        assignmentTypeName: assignmentTypeName,
      },
    );
  };

  editAbstractCourse = async (
    abstractCourseId: number,
    courseName: string,
    courseHours: number,
    attendancePercentage: number,
  ): Promise<AxiosResponse<GenericResponse<SettingsBuilding>>> => {
    return await this.put<SettingsBuilding>(
      `/settings/abstract-course/${abstractCourseId}`,
      {
        courseName: courseName,
        courseHours: courseHours,
        attendancePercentage: attendancePercentage,
      },
    );
  };

  deleteBuilding = async (
    buildingId: number,
  ): Promise<AxiosResponse<GenericResponse<SettingsBuilding>>> => {
    return await this.delete<SettingsBuilding>(
      `/settings/buildings/${buildingId}`,
    );
  };

  addBuildingToBranch = async (
    branchId: number,
    buildingName: string,
  ): Promise<AxiosResponse<GenericResponse<SettingsBuilding>>> => {
    return await this.post<SettingsBuilding>(
      `/settings/branches/${branchId}/buildings`,
      {
        buildingName: buildingName,
      },
    );
  };

  addDocType = async (
    docType: string,
  ): Promise<AxiosResponse<GenericResponse<SettingsDocsType>>> => {
    return await this.post<SettingsDocsType>(`/settings/docs-type`, {
      docType: docType,
    });
  };

  addServicePaymentType = async (
    paymentServiceTypeName: string,
  ): Promise<AxiosResponse<GenericResponse<SettingsServicePaymentType>>> => {
    return await this.post<SettingsServicePaymentType>(
      `/settings/payment-services`,
      {
        serviceTypeName: paymentServiceTypeName,
      },
    );
  };

  addRatingPriceRate = async (
    typeRateName: string,
    paymentType: PaymentType,
  ): Promise<AxiosResponse<GenericResponse<SettingsLecturersRateType>>> => {
    return await this.post<SettingsLecturersRateType>(
      `/settings/lecturers/activity-type`,
      {
        typeRateName: typeRateName,
        paymentType: paymentType,
      },
    );
  };

  /*addRatingPriceRateForLecturer = async (
    branchId: number,
    lecturerId: number,
    priceRateTypeId: number,
    price: number,
    lecturerRateDisplayType: LecturerRateDisplayType,
  ): Promise<AxiosResponse<GenericResponse<SettingsLecturersRateType>>> => {
    return await this.axiosInstance.post(
      `/branches/${branchId}/lecturers/${lecturerId}/payment-rate`,
      {
        lecturersRateTypeId: priceRateTypeId,
        rate: price,
        displayType: lecturerRateDisplayType,
      },
    );
  };*/

  addRequestRatingPriceRateForLecturer = async (
    branchId: number,
    lecturerId: number,
    priceRateTypeId: number,
    requestDescription: string,
    price: number,
    lecturerRateDisplayType: LecturerRateDisplayType,
    startDate: Date,
    endDate: Date,
    requestRateType: RequestRateType,
    fileName: string,
    fileUrl: string,
    fileDescription: string,
    travelRate: number,
    abstractCourseIds: number[],
    legalEntityType: LegalEntityType,
  ): Promise<AxiosResponse<GenericResponse<UserDetailsLecturerRes>>> => {
    return await this.post<UserDetailsLecturerRes>(
      `/branches/${branchId}/lecturers/${lecturerId}/payment-rate/request-add`,
      {
        lecturersRateTypeId: priceRateTypeId,
        rate: price,
        displayType: lecturerRateDisplayType,
        description: requestDescription,
        startTime: startDate,
        endTime: endDate,
        requestType: requestRateType,
        fileName: fileName,
        fileUrl: fileUrl,
        fileDescription: fileDescription,
        travelRate: travelRate,
        abstractCourseIds: abstractCourseIds,
        legalEntityType: legalEntityType,
      },
    );
  };

  updateRequestRateStatus = async (
    branchId: number,
    userId: number,

    isApprove: boolean,
    priceRateTypeId: number,
  ): Promise<AxiosResponse<GenericResponse<BranchLecturerRateEntity>>> => {
    return await this.post<BranchLecturerRateEntity>(
      `/branches/${branchId}/lecturers/${userId}/payment-rate/${priceRateTypeId}/update-status`,
      {
        isApprove: isApprove,
      },
    );
  };

  getAllPaymentServices = async (): Promise<
    AxiosResponse<GenericResponse<PaymentServiceWithVersionsResponseType[]>>
  > => {
    return await this.get<PaymentServiceWithVersionsResponseType[]>(
      `/payment-services/list`,
    );
    //return await axios.get(`${this.baseUrl}/payment-services/list`);
  };

  addClassAttributes = async (
    attributeListName: string,
    attributeName: string,
    attributeType: ClassAttributeType,
  ): Promise<
    AxiosResponse<GenericResponse<SettingsClassesAttributeEntity>>
  > => {
    return await this.post<SettingsClassesAttributeEntity>(
      `/settings/classes-attributes/list`,
      {
        listName: attributeListName,
        attributes: [
          {
            attributeName: attributeName,
            attributeType: attributeType,
          },
        ],
      },
    );
  };

  addClassAttributesToExistingList = async (
    listId: number,

    attributeName: string,
    attributeType: ClassAttributeType,
  ): Promise<
    AxiosResponse<GenericResponse<SettingsClassesAttributeEntity>>
  > => {
    return await this.post<SettingsClassesAttributeEntity>(
      `/settings/classes-attributes/list/${listId}/attributes/`,
      {
        attributeName: attributeName,
        attributeType: attributeType,
      },
    );
  };

  editClassList = async (
    listId: number,
    listName: string,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.put<any>(`/settings/classes-attributes/list/${listId}`, {
      listName: listName,
    });
  };

  editClassAttributes = async (
    listId: number,
    attributeId: number,
    attributeName: string,
  ): Promise<
    AxiosResponse<GenericResponse<SettingsClassesAttributeEntity>>
  > => {
    return await this.put<SettingsClassesAttributeEntity>(
      `/settings/classes-attributes/list/${listId}/attributes/${attributeId}`,
      {
        attributeName: attributeName,
      },
    );
  };

  deleteClassAttribute = async (
    listId: number,
    attributeId: number,
  ): Promise<
    AxiosResponse<GenericResponse<SettingsClassesAttributeEntity>>
  > => {
    return await this.delete<SettingsClassesAttributeEntity>(
      `/settings/classes-attributes/list/${listId}/attributes/${attributeId}`,
    );
  };

  addMajor = async (
    majorName: string,
  ): Promise<AxiosResponse<GenericResponse<ServiceMajorResponse>>> => {
    return await this.post<ServiceMajorResponse>(`/settings/majors`, {
      name: majorName,
    });
  };

  editMajorName = async (
    majorId: number,
    majorName: string,
  ): Promise<AxiosResponse<GenericResponse<ServiceMajorResponse>>> => {
    return await this.put<ServiceMajorResponse>(`/settings/majors/${majorId}`, {
      name: majorName,
    });
  };

  deleteMajor = async (
    majorId: number,
  ): Promise<AxiosResponse<GenericResponse<SettingsAll>>> => {
    return await this.delete<SettingsAll>(`/settings/majors/${majorId}`);
  };

  addAbstractCourse = async (
    courseName: string,
    courseHours: number,
    attendancePercentage: number,
    majorIds: number[],
  ): Promise<AxiosResponse<GenericResponse<AbstractCourse>>> => {
    return await this.post<AbstractCourse>(`/settings/abstract-course`, {
      courseName,
      courseHours,
      attendancePercentage,
      majorIds,
    });
  };

  deleteAbstractCourse = async (
    id: number,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.delete<any>(`/settings/abstract-course/${id}`);
  };

  addAssignmentType = async (
    assignmentTypeName: string,
  ): Promise<AxiosResponse<GenericResponse<AssignmentType>>> => {
    return await this.post<AssignmentType>(`/settings/assignment-type`, {
      assignmentTypeName,
    });
  };

  deleteAssignmentType = async (
    assignmentId: number,
  ): Promise<AxiosResponse<GenericResponse<AssignmentType>>> => {
    return await this.delete<AssignmentType>(
      `/settings/assignment-type/${assignmentId}`,
    );
  };

  editExamTypeName = async (
    examId: number,
    examTypeName: string,
  ): Promise<AxiosResponse<GenericResponse<ExamType>>> => {
    return await this.put<ExamType>(`/settings/exams/${examId}`, {
      examTypeName,
    });
  };

  editSupervisoryInstitutionName = async (
    institutionId: number,
    institutionName: string,
  ): Promise<AxiosResponse<GenericResponse<SupervisoryInstitution>>> => {
    return await this.put<SupervisoryInstitution>(
      `/settings/supervisory-institution/${institutionId}`,
      {
        supervisoryInstitutionName: institutionName,
      },
    );
  };

  addExamType = async (
    examTypeName: string,
  ): Promise<AxiosResponse<GenericResponse<ExamType>>> => {
    return await this.post<ExamType>(`/settings/exams`, {
      examTypeName,
    });
  };

  deleteExamTypeId = async (examTypeId: number) => {
    return await this.delete(`/settings/exams/${examTypeId}`);
  };

  addExternalExam = async (
    examName: string,
    symbol: string,
    majorSymbol: string,
    majorId: number,
    paymentServiceId: number,
  ): Promise<AxiosResponse<GenericResponse<AbstractExternalExam>>> => {
    return await this.post<AbstractExternalExam>(`/settings/external-exams`, {
      examName,
      symbol,
      majorSymbol,
      majorId,
      paymentServiceId,
    });
  };

  updateExternalExam = async (
    externalExamId: number,
    examName: string,
    symbol: string,
    majorSymbol: string,
    majorId: number,
    paymentServiceId: number,
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.put<void>(`/settings/external-exams/${externalExamId}`, {
      examName,
      symbol,
      majorSymbol,
      majorId,
      paymentServiceId,
    });
  };

  deleteExternalExam = async (
    externalExamId: number,
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.delete<void>(
      `/settings/external-exams/${externalExamId}`,
    );
  };

  // External Exam Groups API
  createExternalExamGroup = async (
    request: CreateExternalExamGroupRequest,
  ): Promise<AxiosResponse<GenericResponse<ExternalExamGroup>>> => {
    return await this.post<ExternalExamGroup>(
      `/external-exams-groups`,
      request,
    );
  };

  getExternalExamGroups = async (): Promise<
    AxiosResponse<GenericResponse<ExternalExamGroup[]>>
  > => {
    return await this.get<ExternalExamGroup[]>(`/external-exams-groups`);
  };

  updateExternalExamGroup = async (
    groupId: number,
    request: UpdateExternalExamGroupRequest,
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.put<void>(`/external-exams-groups/${groupId}`, request);
  };

  deleteExternalExamGroup = async (
    groupId: number,
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.delete<void>(`/external-exams-groups/${groupId}`);
  };

  addExamToGroup = async (
    groupId: number,
    request: CreateExternalExamGroupExamRequest,
  ): Promise<AxiosResponse<GenericResponse<ExternalExamGroup>>> => {
    return await this.post<ExternalExamGroup>(
      `/external-exams-groups/${groupId}/exams`,
      request,
    );
  };

  updateExamInGroup = async (
    groupId: number,
    examId: number,
    request: UpdateExternalExamGroupExamRequest,
  ): Promise<AxiosResponse<GenericResponse<ExternalExamGroup>>> => {
    return await this.put<ExternalExamGroup>(
      `/external-exams-groups/${groupId}/exams/${examId}`,
      request,
    );
  };

  deleteExamFromGroup = async (
    groupId: number,
    examId: number,
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.delete<void>(
      `/external-exams-groups/${groupId}/exams/${examId}`,
    );
  };

  getExternalExamRegistrations = async (
    groupId: number,
    examId: number,
    branchIds: number[],
  ): Promise<
    AxiosResponse<GenericResponse<ExternalExamRegistrationStudentDetails[]>>
  > => {
    return await this.post<ExternalExamRegistrationStudentDetails[]>(
      `/external-exams-groups/${groupId}/exams/${examId}/registrations/report`,
      { branchIds },
    );
  };

  deleteExternalExamRegistration = async (
    groupId: number,
    examId: number,
    registrationId: number,
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.delete<void>(
      `/external-exams-groups/${groupId}/exams/${examId}/registrations/${registrationId}`,
    );
  };

  updateExternalExamRegistrationPaymentExempted = async (
    groupId: number,
    examId: number,
    registrationId: number,
    paymentExempted: boolean,
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.put<void>(
      `/external-exams-groups/${groupId}/exams/${examId}/registrations/${registrationId}/payment-exempted`,
      {
        paymentExempted: paymentExempted,
      },
    );
  };

  updateExternalExamRegistrationGrades = async (
    groupId: number,
    examId: number,
    registrationId: number,
    request: {
      attended?: boolean | null;
      internalGrade?: number | null;
      externalGrade?: number | null;
      finalGrade?: number | null;
    },
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.put<void>(
      `/external-exams-groups/${groupId}/exams/${examId}/registrations/${registrationId}/grades`,
      request,
    );
  };

  addExternalExamRegistrations = async (
    groupId: number,
    examId: number,
    request: {
      registrations: {
        userId: number;
        branchId: number;
        programId: number;
        paymentExempted?: boolean;
      }[];
    },
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.post<void>(
      `/external-exams-groups/${groupId}/exams/${examId}/registrations`,
      request,
    );
  };

  registerExternalExam = async (
    groupId: number,
    examId: number,
    registrationId: number,
    registrationSourceType: RegistrationSourceType,
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.put<void>(
      `/external-exams-groups/${groupId}/exams/${examId}/registrations/${registrationId}/register`,
      {
        registrationSourceType: registrationSourceType,
      },
    );
  };

  addSupervisoryInstitution = async (
    supervisoryInstitutionName: string,
  ): Promise<AxiosResponse<GenericResponse<SupervisoryInstitution>>> => {
    return await this.post<SupervisoryInstitution>(
      `/settings/supervisory-institution`,
      {
        supervisoryInstitutionName,
      },
    );
  };

  deleteSupervisoryInstitution = async (
    id: number,
  ): Promise<AxiosResponse<GenericResponse<SupervisoryInstitution>>> => {
    return await this.delete<SupervisoryInstitution>(
      `/settings/supervisory-institution/${id}`,
    );
  };

  createUser = async (
    user: any,
    pass: string,
    branchIds: number[] | null,
  ): Promise<AxiosResponse<GenericResponse<UserSummaryType>>> => {
    return await this.post<UserSummaryType>(`/users`, {
      userDetails: user,
      pass: pass,
      branchIds: branchIds,
    });
  };

  updateUserDetails = async (
    userId: number,
    firstName: string,
    lastName: string,
    nationalId: string,
    phoneNumber: string,
    additionalPhoneNumber: string | null,
    mail: string,
    dateOfBirth: string | null,
    city: string | null,
    street: string | null,
    houseNumber: string | null,
    flatNumber: string | null,
    postcode: string | null,

    gender: Gender | null,
    immigrateCountry: string | null,
    immigrateDate: Date | null,
    maritalStatus: MaritalStatus | null,
  ): Promise<AxiosResponse<GenericResponse<UserSummaryType>>> => {
    return await this.put<UserSummaryType>(`/users/${userId}`, {
      firstName,
      lastName,
      nationalId,
      phoneNumber,
      additionalPhoneNumber,
      email: mail,
      dateOfBirth,
      city,
      street,
      houseNumber,
      flatNumber,
      postcode,
      gender,
      immigrateCountry,
      immigrateDate,
      maritalStatus,
    });
  };

  login = async (email: string, pass: string) => {
    await this.post(`/auth`, {
      email: email,
      password: pass,
    });
  };

  getBranchSchedule = async (
    branchId: number,
    year: number,
    month: number,
  ): Promise<AxiosResponse<GenericResponse<CalendarScheduleFlat[]>>> => {
    return await this.get<CalendarScheduleFlat[]>(
      `/branches/${branchId}/calendar?year=${year}&month=${month}`,
    );
    /*return await axios.get(
      `${this.baseUrl}/branches/${branchId}/calendar?year=${year}&month=${month}`,
    );*/
  };

  getCalendarSlots = async (
    branchId: number,
    startDate: Date,
    iterationNumber: number,
    time: Date,
    durationMinutes: number,
  ): Promise<AxiosResponse<GenericResponse<AvailabilityResponse[]>>> => {
    return await this.get<any>(
      `/branches/${branchId}/calendar/available-slots?startDate=${startDate.toISOString()}&iterationNumber=${iterationNumber}&time=${time.toISOString()}&durationMinutes=${durationMinutes}`,
    );
  };

  getAllSettings = async (): Promise<
    AxiosResponse<GenericResponse<SettingsAll>>
  > => {
    return await this.get<SettingsAll>(`/settings/all`);
  };

  getHome2 = async (): Promise<AxiosResponse<GenericResponse<UserProfile>>> => {
    return await this.get<UserProfile>(`/users/profile`);
  };

  addService = async (
    serviceName: string,
    price: number,
    selectedPaymentServiceTypeId: number,
  ) => {
    return await this.post(`/payment-services`, {
      servicePaymentName: serviceName,
      servicePaymentType: selectedPaymentServiceTypeId,
      price: price,
    });
  };

  updatePaymentServiceName = async (
    paymentServiceId: number,
    paymentServiceName: string,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.put<any>(`/payment-services/${paymentServiceId}`, {
      servicePaymentName: paymentServiceName,
    });
  };

  deletePaymentService = async (
    paymentServiceId: number,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.delete<any>(`/payment-services/${paymentServiceId}`);
  };

  payUserAllocation = async (
    allocationId: number,
    userId: number,
    amount: number,
  ) => {
    return await this.post(
      `/payment-services/allocations/${allocationId}/user/${userId}/pay`,
      {
        amount: amount,
      },
    );
  };

  createPaymentAllocation = async (
    userId: number,
    paymentData: {
      allocations: {
        allocationId: number;
        amount: number;
      }[];
      paymentMethod: 'bank_transfer' | 'cash' | 'scholarship' | 'check';
      paymentDetails?: {
        // Bank Transfer
        bankNumber?: string;
        branchNumber?: string;
        accountNumber?: string;
        transferDate?: Date;
        // Check
        checkNumber?: string;
        dueDate?: Date;
        // Scholarship
        scholarshipId?: number;
      };
      referenceId?: number;
    },
  ): Promise<AxiosResponse<GenericResponse<string>>> => {
    return await this.post<string>(
      `/payment-services/allocations/user/${userId}/pay`,
      paymentData,
    );
  };

  createPaymentInstallments = async (
    userId: number,
    installmentData: {
      allocations: {
        allocationId: number;
        amount: number;
      }[];
      numberOfInstallments: number;
      firstPaymentDate: string;
      paymentDayOfMonth: number;
      creditCardTokenId: number;
    },
  ): Promise<AxiosResponse<GenericResponse<string>>> => {
    return await this.post<string>(
      `/payment-services/installments/user/${userId}`,
      installmentData,
    );
  };

  createBankTransferInstallments = async (
    userId: number,
    installmentData: {
      allocations: {
        allocationId: number;
        amount: number;
      }[];
      numberOfInstallments: number;
      firstPaymentDate: string;
      paymentDayOfMonth: number;
      bankNumber: string;
      branchNumber: string;
      accountNumber: string;
    },
  ): Promise<AxiosResponse<GenericResponse<string>>> => {
    return await this.post<string>(
      `/payment-services/installments/bank-transfer/user/${userId}`,
      installmentData,
    );
  };

  createPaymentServiceAllocation = async (
    userId: number,
    branchId: number,
    paymentServiceId: number,
    paymentServicePriceId: number,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.post<any>(
      `/payment-services/allocations/user/${userId}/branch/${branchId}/create`,
      {
        paymentServiceId: paymentServiceId,
        paymentServicePriceId: paymentServicePriceId,
      },
    );
  };

  getPaymentLink = async (
    allocationId: number,
    userId: number,
    amount: number,
  ): Promise<AxiosResponse<GenericResponse<PaymentResponse>>> => {
    return await this.post<PaymentResponse>(
      `/payment-services/allocations/${allocationId}/user/${userId}/generate-payment-link`,
      {
        amount: amount,
      },
    );
  };

  notifyPaymentComplete = async (
    allocationId: number,
    userId: number,
    pendingPaymentId: number,
  ): Promise<AxiosResponse<GenericResponse<PaymentResponse>>> => {
    return await this.post<PaymentResponse>(
      `/payment-services/allocations/${allocationId}/user/${userId}/notify-payment-complete`,
      {
        pendingPaymentId: pendingPaymentId,
      },
    );
  };

  updateCheckStatus = async (
    paymentId: number,
    checkId: number,
    checkStatus: CheckStatusType,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.put<any>(
      `/payment-services/${paymentId}/checks/${checkId}/status`,
      {
        checkStatus: checkStatus,
      },
    );
  };

  updateProgramStatus = async (
    branchId: number,
    programId: number,
    status: ProgramStatus,
  ) => {
    return await this.put(
      `/branches/${branchId}/programs/${programId}/status`,
      {
        status: status,
      },
    );
  };

  updateProgramActionNumber = async (
    branchId: number,
    programId: number,
    actionNumber: string,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.put<any>(
      `/branches/${branchId}/programs/${programId}/action-number`,
      {
        actionNumber: actionNumber,
      },
    );
  };

  updateProgramNotes = async (
    branchId: number,
    programId: number,
    notes: string,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.put<any>(
      `/branches/${branchId}/programs/${programId}/notes`,
      {
        notes: notes,
      },
    );
  };

  updateProgramStudentStatus = async (
    branchId: number,
    programId: number,
    studentId: number,
    status: ProgramStudentStatus,
    statusDate: Date | null,
  ): Promise<AxiosResponse<GenericResponse<ProgramYearsDistribution>>> => {
    return await this.put<ProgramYearsDistribution>(
      `/branches/${branchId}/programs/${programId}/students/${studentId}/status`,
      {
        status: status,
        statusDate: statusDate,
      },
    );
  };

  updateProgramCourseYear = async (
    branchId: number,
    programId: number,
    courseId: number,
    programYear: number,
  ): Promise<AxiosResponse<GenericResponse<ProgramWithDetails>>> => {
    return await this.put<ProgramWithDetails>(
      `/programs/${programId}/courses/${courseId}/program-year`,
      {
        programYear: programYear,
      },
    );
  };

  addServiceToProgram = async (
    branchId: number,
    programId: number,
    selectedYear: number,
    servicesIds: number[],
  ): Promise<AxiosResponse<GenericResponse<ProgramWithDetails>>> => {
    return await this.post<ProgramWithDetails>(
      `/branches/${branchId}/programs/${programId}/years/${selectedYear}/payment-services/`,
      {
        paymentServicesIds: servicesIds,
      },
    );
  };

  createAbstractProgram = async (data: {
    programName: string;
    programYears: number;
    majorsId: number[];
    institutionId: number[];
    abstractCoursesId: number[];
  }): Promise<AxiosResponse<GenericResponse<AbstractProgram>>> => {
    return await this.post<AbstractProgram>(`/settings/abstract-program`, {
      programName: data.programName,
      programYears: data.programYears,
      majorsId: data.majorsId,
      institutionId: data.institutionId,
      abstractCoursesId: data.abstractCoursesId,
    });
  };

  deleteAbstractProgram = async (
    id: number,
  ): Promise<AxiosResponse<GenericResponse<AbstractProgram>>> => {
    return await this.delete<AbstractProgram>(
      `/settings/abstract-program/${id}`,
    );
  };

  addAbstractProgramCourses = async (
    programId: number,
    abstractCoursesIds: number[],
  ): Promise<AxiosResponse<GenericResponse<AbstractProgram>>> => {
    return await this.post<AbstractProgram>(
      `/settings/abstract-program/${programId}`,
      {
        abstractCoursesIds: abstractCoursesIds,
      },
    );
  };

  deleteAbstractCourseFromAbstractProgram = async (
    programId: number,
    abstractCourseId: number,
  ): Promise<AxiosResponse<GenericResponse<AbstractProgram>>> => {
    return await this.delete<AbstractProgram>(
      `/settings/abstract-program/${programId}/${abstractCourseId}`,
    );
  };

  updateWorkingYears = async (
    currentWorkingYear: number,
    workingYearAvailable: number[],
  ): Promise<AxiosResponse<GenericResponse<AbstractProgram>>> => {
    return await this.put<AbstractProgram>(
      `/settings/working-years-management`,
      {
        currentWorkingYear: currentWorkingYear,
        availableWorkingYears: workingYearAvailable,
      },
    );
  };

  addStudents = async (
    branchId: number,
    programId: number,
    studentsIds: number[],
    programYear: number,
    coursesIds: number[],
  ): Promise<AxiosResponse<GenericResponse<ProgramWithDetails>>> => {
    return await this.post<ProgramWithDetails>(
      `/branches/${branchId}/programs/${programId}/years/${programYear}/add-students`,
      {
        userIds: studentsIds,
        coursesIds: coursesIds,
      },
    );
  };

  addStudentToCourse = async (
    programId: number,
    courseId: number,
    studentsIds: number[],
  ): Promise<AxiosResponse<GenericResponse<null>>> => {
    return await this.post<null>(
      `/programs/${programId}/courses/${courseId}/add-students`,
      {
        userIds: studentsIds,
      },
    );
  };

  addLecturesToCourse = async (
    programId: number,
    courseId: number,
    lecturesIds: number[],
  ) => {
    return await this.post(
      `/programs/${programId}/courses/${courseId}/add-lectures`,
      {
        userIds: lecturesIds,
      },
    );
  };

  startLecture = async (
    programId: number,
    courseId: number,
    lectureId: number,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.post<any>(
      `/programs/${programId}/courses/${courseId}/lectures/${lectureId}/start`,
      {},
    );
  };

  finishLecture = async (
    programId: number,
    courseId: number,
    lectureId: number,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.post<any>(
      `/programs/${programId}/courses/${courseId}/lectures/${lectureId}/finish`,
      {},
    );
  };

  completeLecture = async (
    programId: number,
    courseId: number,
    lectureId: number,
    studentAttendance: UserAttendanceRequest[],
    startTime: Date,
    endTime: Date,
  ): Promise<AxiosResponse<GenericResponse<LectureWithSessions[]>>> => {
    return await this.post<LectureWithSessions[]>(
      `/programs/${programId}/courses/${courseId}/lectures/${lectureId}/complete`,
      {
        attendance: studentAttendance,
        startTime: startTime,
        endTime: endTime,
      },
    );
  };

  upsetLectureAttendance = async (
    programId: number,
    courseId: number,
    lectureId: number,
    studentAttendance: UserAttendanceRequest[],
  ): Promise<AxiosResponse<GenericResponse<LectureWithSessions[]>>> => {
    return await this.post<LectureWithSessions[]>(
      `/programs/${programId}/courses/${courseId}/lectures/${lectureId}/attendance-upsert`,
      {
        attendance: studentAttendance,
      },
    );
  };

  addNewExam = async (
    programId: number,
    courseId: number,
    name: string,
    examTypeId: number,
    completionGrade: boolean,
    points: number,
  ): Promise<AxiosResponse<GenericResponse<ExamMetadata[]>>> => {
    return await this.post<ExamMetadata[]>(
      `/programs/${programId}/courses/${courseId}/exams/`,
      {
        name: name,
        examTypeId: examTypeId,
        completionGrade: completionGrade,
        points: points,
      },
    );
  };

  deleteExam = async (
    programId: number,
    courseId: number,
    examId: number,
  ): Promise<AxiosResponse<GenericResponse<CourseFullInfo>>> => {
    return await this.delete<CourseFullInfo>(
      `/programs/${programId}/courses/${courseId}/exams/${examId}`,
    );
  };

  getSessionQuestionnairePreSignUrl = async (
    programId: number,
    courseId: number,
    examId: number,
    sessionId: number,
    fileType: string,
  ): Promise<AxiosResponse<GenericResponse<string>>> => {
    return await this.get<string>(
      `/programs/${programId}/courses/${courseId}/exams/${examId}/sessions/${sessionId}/files?fileType=${fileType}`,
    );
  };

  uploadExamSessionQuestionnaire = async (
    programId: number,
    courseId: number,
    examId: number,
    sessionId: number,
    fileUrl: string,
    fileName: string,
  ): Promise<AxiosResponse<GenericResponse<ExamSessionDetails[]>>> => {
    return await this.put<ExamSessionDetails[]>(
      `/programs/${programId}/courses/${courseId}/exams/${examId}/sessions/${sessionId}/files/update-questionnaire`,
      {
        fileUrl: fileUrl,
        fileName: fileName,
      },
    );
  };

  deleteExamSessionQuestionnaire = async (
    programId: number,
    courseId: number,
    examId: number,
    sessionId: number,
    fileId: number,
  ): Promise<AxiosResponse<GenericResponse<ExamSessionDetails[]>>> => {
    return await this.delete<ExamSessionDetails[]>(
      `/programs/${programId}/courses/${courseId}/exams/${examId}/sessions/${sessionId}/files/${fileId}`,
    );
  };

  getExamDetails = async (
    programId: number,
    courseId: number,
    examId: number,
  ): Promise<AxiosResponse<GenericResponse<ExamSessionDetails[]>>> => {
    return await this.get<ExamSessionDetails[]>(
      `/programs/${programId}/courses/${courseId}/exams/${examId}/details`,
    );
  };

  addNewExamSession = async (
    programId: number,
    courseId: number,
    examId: number,
    sessionType: SessionType,
  ): Promise<AxiosResponse<GenericResponse<ExamSessionDetails[]>>> => {
    return await this.post<ExamSessionDetails[]>(
      `/programs/${programId}/courses/${courseId}/exams/${examId}`,
      {
        sessionType: sessionType,
      },
    );
  };

  updateExamSessionDate = async (
    programId: number,
    courseId: number,
    examId: number,
    sessionId: number,
    sessionDate: Date,
  ): Promise<AxiosResponse<GenericResponse<ExamSessionDetails[]>>> => {
    return await this.put<ExamSessionDetails[]>(
      `/programs/${programId}/courses/${courseId}/exams/${examId}/sessions/${sessionId}/session-date`,
      {
        sessionDate: sessionDate,
      },
    );
  };

  deleteExamSession = async (
    programId: number,
    courseId: number,
    examId: number,
    sessionId: number,
  ): Promise<AxiosResponse<GenericResponse<ExamSessionDetails[]>>> => {
    return await this.delete<ExamSessionDetails[]>(
      `/programs/${programId}/courses/${courseId}/exams/${examId}/sessions/${sessionId}`,
    );
  };

  updateSessionNotesCollected = async (
    programId: number,
    courseId: number,
    examId: number,
    sessionId: number,
    notesCollected: boolean,
  ): Promise<AxiosResponse<GenericResponse<any[]>>> => {
    return await this.put<any[]>(
      `/programs/${programId}/courses/${courseId}/exams/${examId}/sessions/${sessionId}/notes-collected`,
      {
        notesCollected: notesCollected.toString(),
      },
    );
  };

  updateRegistration = async (
    programId: number,
    courseId: number,
    examId: number,
    sessionId: number,
    startRegistrationDate: Date,
    endRegistrationDate: Date,
  ): Promise<AxiosResponse<GenericResponse<ExamSessionDetails[]>>> => {
    return await this.post<ExamSessionDetails[]>(
      `/programs/${programId}/courses/${courseId}/exams/${examId}/sessions/${sessionId}/update-registration`,
      {
        startRegistrationDate: startRegistrationDate,
        endRegistrationDate: endRegistrationDate,
      },
    );
  };

  addExamClasses = async (
    programId: number,
    courseId: number,
    examId: number,
    sessionId: number,
    schedule: { classId: number; startTime: Date; endTime: Date }[],
  ): Promise<AxiosResponse<GenericResponse<ExamSessionDetails[]>>> => {
    return await this.post<ExamSessionDetails[]>(
      `/programs/${programId}/courses/${courseId}/exams/${examId}/sessions/${sessionId}/schedules`,
      {
        schedules: schedule,
      },
    );
  };

  deleteExamClasses = async (
    programId: number,
    courseId: number,
    examId: number,
    sessionId: number,
    scheduleId: number,
  ): Promise<AxiosResponse<GenericResponse<ExamSessionDetails[]>>> => {
    return await this.delete<ExamSessionDetails[]>(
      `/programs/${programId}/courses/${courseId}/exams/${examId}/sessions/${sessionId}/schedules/${scheduleId}`,
    );
  };

  addExamEnrollment = async (
    programId: number,
    courseId: number,
    examId: number,
    sessionId: number,
    enrollment: RequestEnrollment[],
  ): Promise<AxiosResponse<GenericResponse<ExamSessionDetails[]>>> => {
    return await this.patch<ExamSessionDetails[]>(
      `/programs/${programId}/courses/${courseId}/exams/${examId}/sessions/${sessionId}/enrollment/`,
      {
        enrollment: enrollment,
      },
    );
  };

  updateGradesApproval = async (
    programId: number,
    courseId: number,
    examId: number,
    sessionId: number,
    gradesApproved: boolean,
  ): Promise<AxiosResponse<GenericResponse<ExamSessionDetails[]>>> => {
    return await this.patch<ExamSessionDetails[]>(
      `/programs/${programId}/courses/${courseId}/exams/${examId}/sessions/${sessionId}/enrollment/grades-approval`,
      {
        gradesApproved: gradesApproved,
      },
    );
  };

  addExamProtector = async (
    programId: number,
    courseId: number,
    examId: number,
    sessionId: number,
    protectors: { userId: number; activityTypeId: number; classId: number }[],
  ): Promise<AxiosResponse<GenericResponse<ExamSessionDetails[]>>> => {
    return await this.post<ExamSessionDetails[]>(
      `/programs/${programId}/courses/${courseId}/exams/${examId}/sessions/${sessionId}/protectors/`,
      {
        protectors: protectors,
      },
    );
  };

  getUserAvatarPreSignUrl = async (userId: number, fileType: string) => {
    return await this.get<SettingsAll>(
      `/users/${userId}/details/avatar/pre-sign-url?fileType=${fileType}`,
    );
  };

  uploadUserAvatarPreSignUrl = async (userId: number, fileUrl: string) => {
    return await this.put<any>(`/users/${userId}/details/avatar/`, {
      fileUrl: fileUrl,
    });
  };

  updateUserPermissions = async (
    userId: number,
    permissions: Permission[],
    branches: BranchPermissionStatus[],
  ) => {
    return await this.put(`/users/${userId}/permissions`, {
      permissions: permissions,
      branches: branches,
    });
  };

  addNewDoc = async (
    userId: number,
    docName: string,
    description: string,
    branchId: number | null,
    programId: number | null,
  ): Promise<AxiosResponse<GenericResponse<DocMetadata>>> => {
    const payload = {
      docName: docName,
      docDescription: description,
      branchId: branchId,
      programId: programId,
    };

    return await this.post<DocMetadata>(`/users/${userId}/docs/`, {
      docName: docName,
      docDescription: description,
      branchId: branchId,
      programId: programId,
    });
  };

  addDocFeedback = async (
    userId: number,
    docId: number,
    content: string,
    fileUrl?: string,
  ) => {
    return await this.post(`/users/${userId}/docs/${docId}/feedback-admin`, {
      content: content,
      fileUrl: fileUrl,
    });
  };

  updateDocFeedback = async (
    userId: number,
    docId: number,
    feedbackId: number,
    status: DocFeedbackStatusDB,
  ) => {
    return await this.put(
      `/users/${userId}/docs/${docId}/feedback-admin/status`,
      {
        status: status,
        feedBackId: feedbackId,
      },
    );
  };

  getDocPreSignUrl = async (userId: number, fileType: string) => {
    return await this.get<SettingsAll>(
      `/users/${userId}/docs/pre-sign-url?fileType=${fileType}`,
    );
    /*return await axios.get(
      `${this.baseUrl}/users/${userId}/docs/pre-sign-url?fileType=${fileType}`,
    );*/
  };

  getLectureDetails = async (
    programId: number,
    courseId: number,
    lectureId: number,
  ): Promise<AxiosResponse<GenericResponse<LectureDetails>>> => {
    return await this.get<LectureDetails>(
      `/programs/${programId}/courses/${courseId}/lectures/${lectureId}/details`,
    );

    /*return await axios.get(
      `${this.baseUrl}/programs/${programId}/courses/${courseId}/lectures/${lectureId}/details`,
    );*/
  };

  updateLectureName = async (
    programId: number,
    courseId: number,
    lectureId: number,
    lectureName: string,
  ): Promise<AxiosResponse<GenericResponse<LectureDetails>>> => {
    return await this.put<LectureDetails>(
      `/programs/${programId}/courses/${courseId}/lectures/${lectureId}`,
      { meetingName: lectureName },
    );
  };

  deleteLecture = async (
    programId: number,
    courseId: number,
    lectureId: number,
  ): Promise<AxiosResponse<GenericResponse<CourseFullInfo>>> => {
    return await this.delete<CourseFullInfo>(
      `/programs/${programId}/courses/${courseId}/lectures/${lectureId}`,
    );
  };

  getCities = async (): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await axios.get(
      `https://data.gov.il/api/3/action/datastore_search?resource_id=e9701dcb-9f1c-43bb-bd44-eb380ade542f&limit=2000`,
    );

    /*return await axios.get(
      `${this.baseUrl}/programs/${programId}/courses/${courseId}/lectures/${lectureId}/details`,
    );*/
  };

  updateLecturesSchedules = async (
    programId: number,
    courseId: number,
    lectureId: number,
    schedulesId: number,
    startTime: Date,
    endTime: Date,
    classId: number,
  ): Promise<AxiosResponse<GenericResponse<CourseFullInfo>>> => {
    return await this.put<CourseFullInfo>(
      `/programs/${programId}/courses/${courseId}/lectures/${lectureId}/schedules/${schedulesId}`,
      {
        startTime: startTime,
        endTime: endTime,
        classId: classId,
      },
    );

    /*return await axios.get(
      `${this.baseUrl}/programs/${programId}/courses/${courseId}/lectures/${lectureId}/details`,
    );*/
  };

  uploadFile = async (url: string, file: File) => {
    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/octet-stream',
      },
      body: file,
    });

    return response;
  };

  getContractPreSignUrl = async (
    branchId: number,
    userId: number,
    rateId: number,
    fileType: string,
    isSignContract: boolean,
  ): Promise<AxiosResponse<GenericResponse<{ fileUrl: string }>>> => {
    return await this.get<{ fileUrl: string }>(
      `/branches/${branchId}/lecturers/${userId}/payment-rate/${rateId}/contract/?fileType=${fileType}&isSignContract=${isSignContract}`,
    );
  };

  uploadContract = async (
    branchId: number,
    userId: number,
    rateId: number,
    fileUrl: string,
  ): Promise<AxiosResponse<GenericResponse<{ body: string }>>> => {
    return await this.put<{ body: string }>(
      `/branches/${branchId}/lecturers/${userId}/payment-rate/${rateId}/contract/`,
      {
        fileUrl: fileUrl,
      },
    );
  };

  uploadSignContract = async (
    branchId: number,
    userId: number,
    rateId: number,
    fileUrl: string,
  ): Promise<AxiosResponse<GenericResponse<{ body: string }>>> => {
    return await this.put<{ body: string }>(
      `/branches/${branchId}/lecturers/${userId}/payment-rate/${rateId}/contract/singed-contract`,
      {
        fileUrl: fileUrl,
      },
    );
  };

  getLectures = async (filter: {
    branchId: number | null;
    programs: number[];
    startYear: number | null;
    classes: number[];
    lectureState: LectureStatus[];
    courses: number[];
    courseStatuses: CourseStatus[];
  }): Promise<AxiosResponse<GenericResponse<LecturesResType[]>>> => {
    return await this.post<LecturesResType[]>(
      `/reports/education/lectures`,
      filter,
    );
  };

  addScholarshipFunder = async (
    scholarshipFunder: string,
  ): Promise<AxiosResponse<GenericResponse<ScholarshipFundersEntities>>> => {
    return await this.post<ScholarshipFundersEntities>(
      `/settings/scholarship-funders`,
      {
        scholarshipFunder: scholarshipFunder,
      },
    );
  };

  public async editLecturerRateName(
    rateId: number,
    rateName: string,
  ): Promise<AxiosResponse<GenericResponse<any>>> {
    return this.put<any>(`/settings/lecturers/activity-type/${rateId}`, {
      typeRateName: rateName,
    });
  }

  deleteLecturerRate(
    rateId: number,
  ): Promise<AxiosResponse<GenericResponse<void>>> {
    return this.delete<void>(`/settings/lecturers/activity-type/${rateId}`);
  }

  editPaymentServiceTypeName = async (
    paymentTypeId: number,
    paymentServiceTypeName: string,
  ): Promise<AxiosResponse<GenericResponse<SettingsServicePaymentType>>> => {
    return await this.put<SettingsServicePaymentType>(
      `/settings/payment-services/${paymentTypeId}`,
      {
        serviceTypeName: paymentServiceTypeName,
      },
    );
  };

  editDocTypeName = async (
    docTypeId: number,
    docTypeName: string,
  ): Promise<AxiosResponse<GenericResponse<SettingsDocsType>>> => {
    return await this.put<SettingsDocsType>(
      `/settings/docs-type/${docTypeId}`,
      {
        docType: docTypeName,
      },
    );
  };

  editBranchName = async (
    branchId: number,
    branchName: string,
  ): Promise<AxiosResponse<GenericResponse<SettingsBranches>>> => {
    return await this.put<SettingsBranches>(`/settings/branches/${branchId}`, {
      branchName: branchName,
    });
  };

  deleteBranch = async (
    branchId: number,
  ): Promise<AxiosResponse<GenericResponse<SettingsBranches>>> => {
    return await this.delete<SettingsBranches>(
      `/settings/branches/${branchId}`,
    );
  };

  deleteDocType = async (
    docTypeId: number,
  ): Promise<AxiosResponse<GenericResponse<SettingsDocsType>>> => {
    return await this.delete<SettingsDocsType>(
      `/settings/docs-type/${docTypeId}`,
    );
  };

  editScholarshipFunder = async (
    funderId: number,
    funderName: string,
  ): Promise<AxiosResponse<GenericResponse<ScholarshipFundersEntities>>> => {
    return await this.put<ScholarshipFundersEntities>(
      `/settings/scholarship-funders/${funderId}`,
      {
        scholarshipFunder: funderName,
      },
    );
  };

  createCourseStudentStatus = async (
    name: string,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.post<any>(`/settings/statuses/student/course`, {
      name: name,
    });
  };

  editCourseStudentStatus = async (
    id: number,
    name: string,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.put<any>(`/settings/statuses/student/course/${id}`, {
      name: name,
    });
  };

  deleteCourseStudentStatus = async (
    id: number,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.delete<any>(`/settings/statuses/student/course/${id}`);
  };

  deleteScholarshipFunder = async (
    funderId: number,
  ): Promise<AxiosResponse<GenericResponse<ScholarshipFundersEntities>>> => {
    return await this.delete<ScholarshipFundersEntities>(
      `/settings/scholarship-funders/${funderId}`,
    );
  };

  deletePaymentServiceType = async (
    paymentTypeId: number,
  ): Promise<AxiosResponse<GenericResponse<SettingsServicePaymentType>>> => {
    return await this.delete<SettingsServicePaymentType>(
      `/settings/payment-services/${paymentTypeId}`,
    );
  };

  addCheckStatusPaymentService = async (
    paymentServiceId: number,
    checkStatus: CheckStatusType,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.post<any>(`/settings/check-status-payment-service`, {
      checkStatus: checkStatus,
      paymentServiceId: paymentServiceId,
    });
  };

  deleteCheckStatusPaymentService = async (
    checkId: number,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.delete<any>(
      `/settings/check-status-payment-service/${checkId}`,
    );
  };

  editBuildingName = async (
    branchId: number,
    buildingId: number,
    buildingName: string,
  ): Promise<AxiosResponse<GenericResponse<SettingsBuilding>>> => {
    return await this.put<SettingsBuilding>(
      `/settings/branches/${branchId}/buildings/${buildingId}`,
      {
        buildingName: buildingName,
      },
    );
  };

  removeBranchBuilding = async (
    branchId: number,
    buildingId: number,
  ): Promise<AxiosResponse<GenericResponse<SettingsBuilding>>> => {
    return await this.delete<SettingsBuilding>(
      `/settings/branches/${branchId}/buildings/${buildingId}`,
    );
  };

  addClass = async (
    buildingId: number,
    className: string,
  ): Promise<AxiosResponse<GenericResponse<ClassMetadata>>> => {
    return await this.post<ClassMetadata>(
      `/settings/buildings/${buildingId}/classes`,
      {
        className: className,
      },
    );
  };

  editClassName = async (
    branchId: number,
    buildingId: number,
    classId: number,
    className: string,
  ): Promise<AxiosResponse<GenericResponse<ClassMetadata>>> => {
    return await this.put<ClassMetadata>(
      `/settings/buildings/${buildingId}/classes/${classId}`,
      {
        className: className,
      },
    );
  };

  deleteClass = async (
    branchId: number,
    buildingId: number,
    classId: number,
  ): Promise<AxiosResponse<GenericResponse<ClassMetadata>>> => {
    return await this.delete<ClassMetadata>(
      `/settings/buildings/${buildingId}/classes/${classId}`,
    );
  };

  updateClassAttributeValue = async (
    buildingId: number,
    classId: number,
    attributeId: number,
    numericValue?: number | null | undefined,
    boolValue: boolean | null | undefined,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.put<any>(
      `/settings/buildings/${buildingId}/classes/${classId}/attributes/${attributeId}`,
      {
        boolValue: boolValue,
        numericValue: numericValue,
      },
    );
  };

  updateAssignmentGradesPublished = async (
    programId: number,
    courseId: number,
    assignmentId: number,
    isGradesPublished: boolean,
  ): Promise<AxiosResponse<GenericResponse<CourseFullInfo>>> => {
    return await this.put<CourseFullInfo>(
      `/programs/${programId}/courses/${courseId}/assignments/${assignmentId}/grades-published`,
      {
        isGradesPublished: isGradesPublished,
      },
    );
  };

  updateCourseStudentStatus = async (
    programId: number,
    courseId: number,
    studentId: number,
    statusId: number,
  ): Promise<AxiosResponse<GenericResponse<CourseFullInfo>>> => {
    return await this.put<CourseFullInfo>(
      `/programs/${programId}/courses/${courseId}/students/${studentId}/status`,
      {
        settingCourseStatusId: statusId,
      },
    );
  };

  getAssignmentReport = async (filters: {
    branchIds: number[];
    abstractProgramIds: number[];
    startYears: number[];
    courseStatuses: string[];
    dueDateStart: Date | null;
    dueDateEnd: Date | null;
    isGradesPublished: boolean | null;
    isGradesNotPublished: boolean | null;
  }): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.post<any>('/reports/education/assignments', filters);
  };

  getProgramsReport = async (filters: {
    branchesIds: number[];
    startYears: number[];
    programsStatuses: ProgramStatus[];
  }): Promise<AxiosResponse<GenericResponse<ReportProgramResponseType[]>>> => {
    return await this.post<ReportProgramResponseType[]>(
      '/reports/education/programs',
      filters,
    );
  };

  getExamReport = async (filters: {
    branchesIds: number[];
    programIds: number[];
    startYears: number[];
    statuses: string[];
    examDateStart: Date | null;
    examDateEnd: Date | null;
    examTypes: string[];
    sessions: string[];
    steps: Record<ExamSteps, boolean | null>;
  }): Promise<AxiosResponse<GenericResponse<ExamSessionReport[]>>> => {
    return await this.post<ExamSessionReport[]>(
      '/reports/education/exams',
      filters,
    );
  };

  getGeneralAttendanceReport = async (filters: {
    branchesIds: number[];
    abstractProgramsIds: number[];
    programsStartYears: number[];
    programsStudentStatuses: ProgramStudentStatus[];
    missedRatio: number | null;
    courseStatuses: CourseStatus[];
  }): Promise<
    AxiosResponse<GenericResponse<ReportGeneralAttendanceType[]>>
  > => {
    return await this.post<ReportGeneralAttendanceType[]>(
      '/reports/education/general-attendance',
      filters,
    );
  };

  getDropoutStudentReport = async (filters: {
    branchIds: number[];
    abstractProgramIds: number[];
    startYears: number[];
    dropoutDateStart: Date | null;
    dropoutDateEnd: Date | null;
  }): Promise<AxiosResponse<GenericResponse<StudentDropOutReportDb[]>>> => {
    return await this.post<StudentDropOutReportDb[]>(
      '/reports/education/dropout-students',
      filters,
    );
  };

  getLecturesReport = async (filters: {
    branchesIds: number[];
    abstractProgramIds: number[];
    programsStartYears: number[];
    lectureState: LectureStatusType[];
    dateRangeStart: Date | null;
    dateRangeEnd: Date | null;
  }): Promise<AxiosResponse<GenericResponse<ReportLecturesType[]>>> => {
    return await this.post<ReportLecturesType[]>(
      '/reports/education/lectures/issues',
      {
        ...filters,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
    );
  };

  getStudentByStatusInCourseReport = async (filters: {
    branchIds: number[];
    abstractProgramIds: number[];
    startYears: number[];
    courseStudentStatuses: string[];
    programStudentStatuses: string[];
  }): Promise<
    AxiosResponse<GenericResponse<StudentStatusInCourseReportResultDb[]>>
  > => {
    return await this.post<StudentStatusInCourseReportResultDb[]>(
      `/reports/education/student-courses/status`,
      filters,
    );
  };

  getCourseExceedingHours = async (filters: {
    branchIds: number[];
    startYears: number[];
    courseStatuses: CourseStatus[];
    exceedingHours: number | null;
  }): Promise<AxiosResponse<GenericResponse<CourseHoursExceedingReport[]>>> => {
    return await this.post<CourseHoursExceedingReport[]>(
      '/reports/finance/course-exceeding-hours',
      filters,
    );
  };

  getCourseFinancialAmongAllBranches = async (filters: {
    branchIds: number[];
    programId: string | null;
    startYears: number[];
    courseId: string | null;
    courseStatus: CourseStatus | null;
  }): Promise<
    AxiosResponse<GenericResponse<CourseFinancialAmongBranchesType[]>>
  > => {
    return await this.post<CourseFinancialAmongBranchesType[]>(
      '/reports/finance/course-among-branches',
      filters,
    );
  };

  getCourseFinancialInBranch = async (filters: {
    branchId: number | null;
    programId: number | null;
    years: number[];
    courseId: number | null;
    courseStatus: CourseStatus | null;
  }): Promise<AxiosResponse<GenericResponse<FinancialData[]>>> => {
    return await this.post<FinancialData[]>(
      '/reports/finance/course-branch-breakdown',
      filters,
    );
  };

  getRealEstateReport = async (filters: {
    buildingIds: number[];
    dateRangeStart: Date | null;
    dateRangeEnd: Date | null;
    timeRangeStart: Date | null;
    timeRangeEnd: Date | null;
    timezone: string;
  }): Promise<AxiosResponse<GenericResponse<RealEstateReportType[]>>> => {
    return await this.post<RealEstateReportType[]>(
      '/reports/finance/real-estate-utilization',
      filters,
    );
  };

  getStudentFinancialDept = async (filters: {
    branchesIds: string[];
    programIds: string[];
    startYears: number[];
    statuses: string[];
    minDebtAmount: number | null;
  }): Promise<AxiosResponse<GenericResponse<RealEstateReportType[]>>> => {
    return await this.post<RealEstateReportType[]>(
      '/reports/finance/students-dept',
      filters,
    );
  };

  getProgramComparisonByBranches = async (filters: {
    branchIds: number[];
    abstractProgramIds: number[];
    startYears: number[] | null;
    studyYears: number[];
  }): Promise<
    AxiosResponse<GenericResponse<ProgramComparisonAmongBranchesDb[]>>
  > => {
    return await this.post<ProgramComparisonAmongBranchesDb[]>(
      '/reports/finance/program-comparison-among-branches',
      filters,
    );
  };

  getProgramComparisonByBranches2 = async (filters: {
    branchId: number;
    programId: number;
  }): Promise<AxiosResponse<GenericResponse<ProgramFinancialBreakdown>>> => {
    return await this.post<ProgramFinancialBreakdown>(
      '/reports/finance/breakdown',
      filters,
    );
  };

  getChecksReport = async (filters: {
    branchIds: number[];
    paymentCollectionStartDate: Date | null;
    paymentCollectionEndDate: Date | null;
    checkRepaymentStartDate: Date | null;
    checkRepaymentEndDate: Date | null;
    checkStatuses: CheckStatusType[];
  }): Promise<AxiosResponse<GenericResponse<CheckType[]>>> => {
    return await this.post<CheckType[]>('/reports/accountant/checks', filters);
  };

  getInstallmentsReport = async (filters: {
    startDate: string | null;
    endDate: string | null;
    paymentStatus: PaymentInstallmentStatus[];
  }): Promise<AxiosResponse<GenericResponse<InstallmentReportRow[]>>> => {
    return await this.post<InstallmentReportRow[]>(
      '/reports/accountant/installments',
      filters,
    );
  };

  getInstallmentsBankTransferReport = async (filters: {
    startDate: string | null;
    endDate: string | null;
    paymentStatus: PaymentInstallmentStatus[];
  }): Promise<
    AxiosResponse<GenericResponse<InstallmentBankTransferReportRow[]>>
  > => {
    return await this.post<InstallmentBankTransferReportRow[]>(
      '/reports/accountant/installments-bank-transfer',
      filters,
    );
  };

  payAllInstallments = async (
    startDate: string,
    endDate: string,
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.post<void>('/payment-services/installments/pay', {
      startDate,
      endDate,
    });
  };

  deleteInstallmentPlan = async (
    installmentPlanId: number,
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.delete<void>(
      `/payment-services/installments/${installmentPlanId}`,
    );
  };

  deleteInstallmentPlanBankTransfer = async (
    installmentPlanId: number,
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.delete<void>(
      `/payment-services/installments/bank-transfer/${installmentPlanId}`,
    );
  };

  addToExistingInstallmentPlan = async (
    installmentPlanId: number,
    userId: number,
    allocations: { allocationId: number; amount: number }[],
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.put<void>(
      `/payment-services/installments/user/${userId}/${installmentPlanId}/allocations`,
      { allocations },
    );
  };

  addToExistingInstallmentPlanBankTransfer = async (
    installmentPlanId: number,
    userId: number,
    allocations: { allocationId: number; amount: number }[],
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.put<void>(
      `/payment-services/installments/bank-transfer/user/${userId}/${installmentPlanId}/allocations`,
      { allocations },
    );
  };

  addClassAttributesToClass = async (
    buildingId: number,
    classId: number,
    listId: number,
    attributeValues: {
      attributeId: number;
      numericValue?: number;
      boolValue?: boolean;
    }[],
  ): Promise<AxiosResponse<GenericResponse<SettingsAll>>> => {
    return await this.post<SettingsAll>(
      `/settings/buildings/${buildingId}/classes/${classId}/attributes/list/${listId}/values`,
      {
        values: attributeValues,
      },
    );
  };

  getHighOverview = async (
    realEstateUsageDateRangeStart: Date,
    realEstateUsageDateRangeEnd: Date,
    realEstateUsageTimeInHoursStart: string,
    realEstateUsageTimeInHoursEnd: string,

    academicYear: number,

    financialMeasureDateRangeStart: Date,
    financialMeasureDateRangeEnd: Date,

    examsDateRangeStart: Date,
    examsDateRangeEnd: Date,
  ): Promise<AxiosResponse<GenericResponse<HighOverviewReportTypeRes>>> => {
    return await this.post<HighOverviewReportTypeRes>(`reports/high-overview`, {
      /*programsStartYears: programsStartYears,*/
      realEstateUsageDateRangeStart: realEstateUsageDateRangeStart,
      realEstateUsageDateRangeEnd: realEstateUsageDateRangeEnd,
      realEstateUsageTimeInHoursStart: realEstateUsageTimeInHoursStart,
      realEstateUsageTimeInHoursEnd: realEstateUsageTimeInHoursEnd,

      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      weekDays: [
        WeekDay.Sunday,
        WeekDay.Monday,
        WeekDay.Tuesday,
        WeekDay.Wednesday,
        WeekDay.Thursday,
      ],

      academicYear: academicYear,

      financialMeasureDateRangeStart: financialMeasureDateRangeStart,
      financialMeasureDateRangeEnd: financialMeasureDateRangeEnd,
      examsDateRangeStart: examsDateRangeStart,
      examsDateRangeEnd: examsDateRangeEnd,
    });
  };

  updateLecturerAccountantData = async (
    branchId: number,
    lecturerId: number,
    rateId: number,
    legalEntityType: LegalEntityType,
    reportingCode: string,
    legalEntityId: string | null,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.post<any>(
      `/branches/${branchId}/lecturers/${lecturerId}/payment-rate/accountant`,
      {
        branchId: branchId,
        lecturerId: lecturerId,
        rateId: rateId,
        legalEntityType: legalEntityType,
        reportingCode: reportingCode,
        legalEntityId: legalEntityId,
      },
    );
  };

  retrieveEmployeeSalaryStatus = async (
    startDate: Date,
    endDate: Date,
    shouldIncludeRetroactive: boolean,
  ): Promise<
    AxiosResponse<GenericResponse<ProfessorsSalariesStatusesType>>
  > => {
    return await this.post<ProfessorsSalariesStatusesType>(
      `accountant/salaries/status`,
      {
        startDate: startDate,
        endDate: endDate,
        shouldIncludeRetroactive: shouldIncludeRetroactive,
      },
    );
  };

  generatePayrollReport = async (
    userId: number,
    startTime: Date,
    endTime: Date,
    includeRetroactivePayments: boolean,
  ): Promise<AxiosResponse<GenericResponse<PendingPaymentBranch[]>>> => {
    return await this.post<PendingPaymentBranch[]>(
      `accountant/salaries/professors/${userId}/payroll`,
      {
        userId: userId,
        startTime: startTime,
        endTime: endTime,
        includeRetroactivePayments: includeRetroactivePayments,
      },
    );
  };

  payProfessorSalary = async (
    userId: number,
    workingHourIds: { workingHourId: number; rateId: number }[],
  ): Promise<AxiosResponse<GenericResponse<PendingPaymentBranch[]>>> => {
    return await this.post<PendingPaymentBranch[]>(
      `accountant/salaries/professors/${userId}/payroll/execute-salary`,
      {
        workingHoursIds: workingHourIds,
      },
    );
  };

  getSalaryHistory = async (
    startDate: Date,
    endDate: Date,
  ): Promise<AxiosResponse<GenericResponse<SalaryHistoryDbType[]>>> => {
    return await this.post<SalaryHistoryDbType[]>(
      `accountant/salaries/history`,
      {
        startDate: startDate,
        endDate: endDate,
      },
    );
  };

  getProfessorSalaryHistory = async (
    userId: number,
    startDate: Date,
    endDate: Date,
  ): Promise<AxiosResponse<GenericResponse<SalaryHistoryDbType[]>>> => {
    return await this.post<SalaryHistoryDbType[]>(
      `users/professor/${userId}/`,
      {
        startDate: startDate,
        endDate: endDate,
      },
    );
  };

  getWorkingHours = async (
    userId: number,
    startDate: Date,
    endDate: Date,
  ): Promise<AxiosResponse<GenericResponse<WorkingHoursResponse[]>>> => {
    return await this.post<WorkingHoursResponse[]>(`working-hours/${userId}`, {
      startDate: startDate,
      endDate: endDate,
    });
  };

  addManualWorkingHours = async (
    userId: number,
    branchId: number,
    activityTypeId: number,
    rateId: number,
    startTime: Date,
    endTime: Date,
  ): Promise<AxiosResponse<GenericResponse<WorkingHoursResponse[]>>> => {
    return await this.post<WorkingHoursResponse[]>(
      `working-hours/${userId}/manual`,
      {
        branchId: branchId,
        activityTypeId: activityTypeId,
        rateId: rateId,
        startTime: startTime,
        endTime: endTime,
      },
    );
  };

  updateManualWorkingHours = async (
    workingHourId: number,
    userId: number,
    branchId: number,
    activityTypeId: number,
    rateId: number,
    startTime: Date,
    endTime: Date,
  ): Promise<AxiosResponse<GenericResponse<WorkingHoursResponse[]>>> => {
    return await this.post<WorkingHoursResponse[]>(
      `working-hours/${userId}/manual/${workingHourId}`,
      {
        branchId: branchId,
        activityTypeId: activityTypeId,
        rateId: rateId,
        startTime: startTime,
        endTime: endTime,
      },
    );
  };

  updateManualWorkingHoursStatus = async (
    workingHourId: number,
    workingHoursStatus: WorkingHoursStatus,
  ): Promise<AxiosResponse<GenericResponse<WorkingHoursResponse[]>>> => {
    return await this.put<WorkingHoursResponse[]>(
      `working-hours/${workingHourId}`,
      {
        workingHoursStatus: workingHoursStatus,
      },
    );
  };

  requestAdditionalCourseHours = async (
    programId: number,
    courseId: number,
    requestedAdditionalHours: number,
    justification: string,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.post<any>(
      `/programs/${programId}/courses/${courseId}/request-hours/`,
      {
        requestedAdditionalHours: requestedAdditionalHours,
        justification: justification,
      },
    );
  };

  updateCourseHoursRequestStatus = async (
    programId: number,
    courseId: number,
    requestId: number,
    status: string,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.put<any>(
      `/programs/${programId}/courses/${courseId}/request-hours/${requestId}/status`,
      {
        status: status,
      },
    );
  };

  updateCourseHoursRequest = async (
    programId: number,
    courseId: number,
    requestId: number,
    newHours: number,
    newJustification: string,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.put<any>(
      `/programs/${programId}/courses/${courseId}/request-hours/${requestId}`,
      {
        requestedAdditionalHours: newHours,
        justification: newJustification,
      },
    );
  };

  processPaymentRefund = async (
    allocationId: number,
    userId: number,
    userPaymentId: number,
    userPaymentItemId: number,
    refundAmount: number,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.post<any>(
      `/payment-services/allocations/${allocationId}/user/${userId}/payments/${userPaymentId}/payment-items/${userPaymentItemId}/refund`,
      {
        refundAmount: refundAmount,
      },
    );
  };

  addUserRoleDocumentRequirement = async (
    userRole: UserType,
    docTypeId: number,
    docName: string,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.post<any>(
      `/settings/default-user-document-requirements/`,
      {
        userRole: userRole,
        docTypeId: docTypeId,
        docName: docName,
      },
    );
  };

  editUserRoleDocumentRequirement = async (
    mappingUserRoleToDocTypeId: number,
    userRole: UserType,
    docTypeId: number,
    docName: string,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.put<any>(
      `/settings/default-user-document-requirements/${mappingUserRoleToDocTypeId}`,
      {
        userRole: userRole,
        docTypeId: docTypeId,
        docName: docName,
      },
    );
  };

  deleteUserRoleDocumentRequirement = async (
    id: number,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.delete<any>(
      `/settings/default-user-document-requirements/${id}`,
    );
  };

  sendPasswordResetOtp = async (
    resetType: PasswordResetType,
  ): Promise<AxiosResponse<GenericResponse<{ token: string }>>> => {
    return await this.post<{ token: string }>(
      '/auth/reset-password/request-otp',
      {
        resetType: resetType,
      },
    );
  };

  verifyPasswordResetOtp = async (
    token: string,
    otp: number,
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.post<void>('/auth/reset-password/verify-otp', {
      token: token,
      otp: otp,
    });
  };

  updatePassword = async (
    token: string,
    password: string,
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.post<void>('/auth/reset-password/update-password', {
      token: token,
      password: password,
    });
  };

  getRateSummary = async (
    rateId: number,
    branchId: number,
    userId: number,
    branchIds: number[],
    startTime: Date,
    endTime: Date,
    activityTypeId: number,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.post<any>(
      `/branches/${branchId}/lecturers/${userId}/payment-rate/rate-summary`,
      {
        rateId: rateId,
        branchIds: branchIds,
        startTime: startTime,

        endTime: endTime,

        activityTypeId: activityTypeId,
      },
    );
  };

  manualFinishLecture = async (
    branchId: number,
    programId: number,
    courseId: number,
    lectureId: number,
    sessionId: number,
    endTime: Date,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.put<any>(
      `/programs/${programId}/courses/${courseId}/lectures/${lectureId}/sessions/${sessionId}/manual-finish`,
      {
        endTime: endTime,
      },
    );
  };

  logout = async (): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.post<void>('/auth/logout', {});
  };

  // Poll API methods
  createAbstractPoll = async (
    pollName: string,
  ): Promise<AxiosResponse<GenericResponse<PollWithQuestionsResponse>>> => {
    return await this.post<PollWithQuestionsResponse>(
      `/settings/abstract-poll`,
      {
        pollName: pollName,
      },
    );
  };

  updateAbstractPollName = async (
    pollId: number,
    pollName: string,
  ): Promise<AxiosResponse<GenericResponse<PollWithQuestionsResponse>>> => {
    return await this.put<PollWithQuestionsResponse>(
      `/settings/abstract-poll/${pollId}`,
      {
        pollName: pollName,
      },
    );
  };

  deleteAbstractPoll = async (
    pollId: number,
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.delete<void>(`/settings/abstract-poll/${pollId}`);
  };

  // Poll Question API methods
  createPollQuestion = async (
    pollId: number,
    questionText: string,
    questionType: string,
    options?: {
      optionText: string;
      optionValue: number;
      optionOrder: number;
    }[],
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.post<void>(
      `/settings/abstract-poll/${pollId}/questions`,
      {
        questionText,
        questionType,
        options,
      },
    );
  };

  updatePollQuestionText = async (
    pollId: number,
    questionId: number,
    questionText: string,
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.put<void>(
      `/settings/abstract-poll/${pollId}/questions/${questionId}`,
      {
        questionText,
      },
    );
  };

  deletePollQuestion = async (
    pollId: number,
    questionId: number,
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.delete<void>(
      `/settings/abstract-poll/${pollId}/questions/${questionId}`,
    );
  };

  updatePollQuestionsOrder = async (
    pollId: number,
    questionsOrder: { questionId: number; orderItem: number }[],
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.put<void>(
      `/settings/abstract-poll/${pollId}/questions/order`,
      {
        orders: questionsOrder,
      },
    );
  };

  // Poll Option API methods
  addPollQuestionOption = async (
    pollId: number,
    questionId: number,
    optionText: string,
    optionValue: number,
    optionOrder: number,
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.post<void>(
      `/settings/abstract-poll/${pollId}/questions/${questionId}/options`,
      {
        optionText,
        optionValue,
        optionOrder,
      },
    );
  };

  updatePollQuestionOption = async (
    pollId: number,
    questionId: number,
    optionId: number,
    optionText: string,
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.put<void>(
      `/settings/abstract-poll/${pollId}/questions/${questionId}/options/${optionId}`,
      {
        optionText,
      },
    );
  };

  deletePollQuestionOption = async (
    pollId: number,
    questionId: number,
    optionId: number,
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.delete<void>(
      `/settings/abstract-poll/${pollId}/questions/${questionId}/options/${optionId}`,
    );
  };

  // Course Feedback Poll API methods
  createCourseFeedbackPoll = async (
    programId: number,
    courseId: number,
    professorId: number,
    settingsAbstractPollId: number,
    isActive: boolean,
    isAnonymous: boolean,
    blockGradeView: boolean,
  ): Promise<AxiosResponse<GenericResponse<any>>> => {
    return await this.post<any>(
      `/programs/${programId}/courses/${courseId}/professor-feedbacks`,
      {
        professorId,
        settingsAbstractPollId,
        isActive,
        isAnonymous,
        blockGradeView,
      },
    );
  };

  updateCourseFeedbackPoll = async (
    programId: number,
    courseId: number,
    feedbackId: number,
    isActive: boolean,
    isAnonymous: boolean,
    blockGradeView: boolean,
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.put<void>(
      `/programs/${programId}/courses/${courseId}/professor-feedbacks/${feedbackId}`,
      {
        isActive,
        isAnonymous,
        blockGradeView,
      },
    );
  };

  deleteCourseFeedbackPoll = async (
    programId: number,
    courseId: number,
    feedbackId: number,
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.delete<void>(
      `/programs/${programId}/courses/${courseId}/professor-feedbacks/${feedbackId}`,
    );
  };

  // Student Course Feedback Answer API
  submitCourseFeedbackAnswers = async (
    programId: number,
    courseId: number,
    feedbackId: number,
    answers: {
      questionId: number;
      selectedOptionId?: number | null;
      textResponse?: string | null;
    }[],
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.post<void>(
      `/programs/${programId}/courses/${courseId}/professor-feedbacks/${feedbackId}/answers`,
      {
        answers,
      },
    );
  };

  // Teaching Feedback Report API (Professor Course Polls)
  getProfessorCoursePollsReport = async (filters: {
    branchIds: number[];
    abstractCourseId: number | null;
    settingsAbstractPollId: number | null;
  }): Promise<AxiosResponse<GenericResponse<any[]>>> => {
    return await this.post<any[]>('/reports/education/polls', filters);
  };

  // Credit Card Token API
  generateCreditCardTokenLink = async (
    userId: number,
  ): Promise<
    AxiosResponse<
      GenericResponse<{
        url: string;
        sessionId: string;
        transactionId: string;
        confirmationId: string;
      }>
    >
  > => {
    return await this.post<{
      url: string;
      sessionId: string;
      transactionId: string;
      confirmationId: string;
    }>(`/payment-gateway/user/${userId}/token/generate-link`, {});
  };

  verifyCreditCardToken = async (
    userId: number,
    transactionId: string,
    confirmationId: string,
  ): Promise<AxiosResponse<GenericResponse<void>>> => {
    return await this.put<void>(
      `/payment-gateway/user/${userId}/token/verify-token`,
      {
        transactionId,
        confirmationId,
      },
    );
  };
}

export default new AppApi();
